module.exports = __webpack_public_path__ + "static/media/ic-arrow-right.260c04c9.svg";